import { useEffect, useRef } from 'react';
import QuizQuestionCard from '../QuizQuestionCard/QuizQuestionCard';
import styles from './QuestionNavigationPanel.module.css';

const QuestionNavigationPanel = ({ questions, currentIndex, onQuestionSelect, isAnsweredFn }) => {
  const cardRefs = useRef([]);

  useEffect(() => {
    if (cardRefs.current[currentIndex]) {
      cardRefs.current[currentIndex].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [currentIndex]);

  return (
    <div className={styles.panelWrapper}>
      {questions.map((question, index) => (
        <QuizQuestionCard
          key={question._id || index}
          index={index}
          isAnswered={isAnsweredFn(question, index)}
          isActive={index === currentIndex}
          onClick={() => onQuestionSelect(index)}
          ref={(el) => (cardRefs.current[index] = el)}
        />
      ))}
    </div>
  );
};

export default QuestionNavigationPanel;